(() => {
  const init = (root) => {
    const choices = [...root.querySelectorAll('[data-lf-situation-choice]')];
    const image = root.querySelector('.lf-situation-scene__image');
    const room = root.querySelector('[data-lf-situation-room]');
    const text = root.querySelector('[data-lf-situation-copy]');
    if (!choices.length || !image) return;
    choices.forEach((button) => button.addEventListener('click', () => {
      image.src = button.dataset.imageSrc;
      image.srcset = '';
      image.alt = button.dataset.imageAlt || '';
      if (room) room.textContent = button.dataset.room || '';
      if (text) text.textContent = button.dataset.copy || '';
      choices.forEach((choice) => {
        const active = choice === button;
        choice.setAttribute('aria-pressed', active ? 'true' : 'false');
        choice.classList.toggle('is-active', active);
      });
    }));
  };
  const start = () => document.querySelectorAll('.lf-situation-scene[data-lf-situation-gallery]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();